// src/components/Privacy.js
import styled from "styled-components";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <Wrap>
      <Inner>
        <Top>
          <H1>Privacy Policy</H1>
          <Meta>
            Catching Gold Diggers
            <Dot>•</Dot>
            Last updated: <strong>[2026]</strong>
          </Meta>

          <Intro>
            We created this Privacy Policy to show our commitment to respecting your privacy. This
            policy explains how we collect, use, share, and protect information relating to
            visitors and subscribers (together, <strong>you</strong>) of Catching Gold Diggers (the{" "}
            <strong>Site</strong>).
          </Intro>

          <Intro>
            This is an adult website and access is restricted to adults. Persons under the age of{" "}
            <strong>18</strong> are strictly prohibited from the Site and we do not knowingly
            collect personal information from anyone under 18. By visiting or subscribing to the
            Site, you agree to this Privacy Policy and our{" "}
            <StyledLink to="/terms">Terms</StyledLink>.
          </Intro>
        </Top>

        <Section>
          <H2>1. Information We Collect</H2>
          <P>
            We may collect <strong>personal information</strong> you provide directly, such as your
            email address, subscription status, and any information you submit through forms or
            support requests.
          </P>
          <P>
            We also collect <strong>non personal information</strong> automatically when you use
            the Site, such as browser type, operating system, device identifiers, approximate
            location, IP address, referring pages, and usage data (for example, pages visited and
            time spent).
          </P>
        </Section>

        <Section>
          <H2>2. Cookies and Similar Technologies</H2>
          <P>
            We use cookies and similar technologies to operate the Site, remember preferences, keep
            you logged in (where applicable), understand how the Site is used, and improve
            performance.
          </P>
          <P>
            We may also allow unaffiliated third parties (for example, analytics providers or
            advertising partners, if used) to set cookies or similar technologies. We do not track
            you once you leave our Site, but third parties may collect information under their own
            policies.
          </P>
          <P>
            You can usually disable cookies through your browser settings. If you disable cookies,
            some features of the Site may not function properly.
          </P>
        </Section>

        <Section>
          <H2>3. How We Use Information</H2>
          <P>
            We collect information to operate the Site, manage subscriptions, provide support, and
            improve your experience. We may use information for purposes including:
          </P>
          <List>
            <li>to provide and administer the Site and subscriber features</li>
            <li>to process subscriptions and manage account access (subscription only platform)</li>
            <li>to respond to support requests and communicate service updates</li>
            <li>to diagnose problems with our servers and improve Site performance</li>
            <li>to understand how visitors use the Site and improve content and usability</li>
            <li>to protect the security and integrity of the Site and prevent fraud or abuse</li>
            <li>
              to send occasional promotional messages from us, where permitted by law, and where you
              have not opted out
            </li>
          </List>
          <P>
            We aim to respect your time and inbox by limiting the frequency of marketing emails. You
            can opt out of promotional emails at any time using the unsubscribe link (where
            provided) or by contacting us.
          </P>
        </Section>

        <Section>
          <H2>4. Subscription Payments</H2>
          <P>
            Catching Gold Diggers is subscription only. Payments may be processed by authorised
            third party payment processors (for example, CCBill or Segpay). We do not store full
            payment card details on our servers. Payment processors handle payment data under their
            own privacy and security practices.
          </P>
        </Section>

        <Section>
          <H2>5. Sharing Information</H2>
          <P>
            We may share information in limited circumstances, including:
          </P>
          <List>
            <li>
              with service providers who help us operate the Site (for example, hosting, analytics,
              customer support tools), only as necessary to provide their services
            </li>
            <li>
              with payment processors to manage subscriptions and billing (subscription access)
            </li>
            <li>
              to comply with legal obligations, lawful requests, or to protect rights, safety, and
              security
            </li>
            <li>
              in connection with a business transfer (for example, merger, acquisition, or sale of
              assets), where permitted by law
            </li>
          </List>
          <P>
            If the Site includes ads or links to third party sites, those third parties may collect
            information under their own privacy policies. We do not control or endorse third party
            information practices and we are not responsible for their policies or actions.
          </P>
        </Section>

        <Section>
          <H2>6. Email Communications</H2>
          <P>
            We may contact you to provide important service notices (for example, subscription
            access, account security, or policy updates). We may also send occasional marketing
            messages, where permitted, and you can opt out at any time.
          </P>
          <P>
            If you believe you have received unsolicited email that claims to be from Catching Gold
            Diggers, forward it to <strong>[support@catchinggolddiggers.com]</strong> with any relevant
            details.
          </P>
        </Section>

        <Section>
          <H2>7. Security</H2>
          <P>
            We use reasonable security measures intended to protect information under our control
            from loss, misuse, and unauthorised access or alteration. However, no method of
            transmission over the internet is completely secure, and we cannot guarantee absolute
            security.
          </P>
          <P>
            Visitors and subscribers should treat communications over the internet as potentially
            non confidential. We are not responsible for information intercepted by third parties
            outside of our reasonable control.
          </P>
        </Section>

        <Section>
          <H2>8. Data Retention</H2>
          <P>
            We retain personal information only as long as necessary for the purposes described in
            this Privacy Policy, including to provide the Service, comply with legal obligations,
            resolve disputes, and enforce our agreements.
          </P>
        </Section>

        <Section>
          <H2>9. Your Rights (UK)</H2>
          <P>
            Depending on your circumstances, you may have rights under UK data protection laws,
            including rights to request access, correction, deletion, or restriction of certain
            personal information, and to object to certain processing.
          </P>
          <P>
            To make a request, contact us at <strong>[support@catchinggolddiggers.com]</strong>. We may need
            to verify your identity before responding.
          </P>
        </Section>

        <Section>
          <H2>10. International Access</H2>
          <P>
            The Site is operated from the United Kingdom. If you access the Site from outside the
            UK, you understand your information may be processed in the UK or other jurisdictions
            where our service providers operate.
          </P>
        </Section>

        <Section>
          <H2>11. Changes to This Privacy Policy</H2>
          <P>
            We may update this Privacy Policy from time to time. The “Last updated” date will change
            when updates are made. Your continued use of the Site after updates means you accept the
            revised policy.
          </P>
        </Section>

        <Section>
          <H2>12. Contact</H2>
          <P>
            If you have questions about this Privacy Policy or how we handle information, contact:
          </P>
          <List>
            <li>
              Email: <strong>[support@catchinggolddiggers.com]</strong>
            </li>
            <li>
              Registered office: <strong>[Registered office address]</strong>
            </li>
          </List>
        </Section>

        <BottomNav>
          <BackLink to="/">Back to Home</BackLink>
        </BottomNav>
      </Inner>
    </Wrap>
  );
};

export default Privacy;

/* ---------- styles ---------- */

const Wrap = styled.div`
  background: #000;
  color: #fff;
  min-height: 100vh;
  padding: 60px 0;
`;

const Inner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 80px;

  @media (max-width: 868px) {
    padding: 0 35px;
  }

  @media (max-width: 568px) {
    padding: 0 20px;
  }
`;

const Top = styled.div`
  margin-bottom: 26px;
`;

const H1 = styled.h1`
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: -0.4px;

  @media (max-width: 568px) {
    font-size: 28px;
  }
`;

const Meta = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
`;

const Dot = styled.span`
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.35);
`;

const Intro = styled.p`
  margin: 14px 0 0;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
`;

const Section = styled.section`
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

const H2 = styled.h2`
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 800;
`;

const P = styled.p`
  margin: 0 0 10px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
`;

const List = styled.ul`
  margin: 0 0 10px;
  padding-left: 18px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.65;

  li {
    margin: 6px 0;
  }
`;

const StyledLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: underline;
`;

const BottomNav = styled.div`
  margin-top: 34px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: flex-start;
`;

const BackLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;
